export default __webpack_public_path__ + "assets/webgl/complete-12.57c0a9ee.jpg";